import React from 'react';
import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import './OpenClawClose.css';

const OpenClawClose = ({ ctaLabel, onGetApiKey }) => {
  return (
    <section className="openclaw-close">
      <div className="openclaw-close__gradient" aria-hidden="true" />
      <div className="section openclaw-close__inner">
        <h2 className="openclaw-close__title display-font">
          One API key.
          <br />
          <span className="openclaw-close__title-accent">
            Every capability your agents need.
          </span>
        </h2>
        <p className="openclaw-close__body">
          CellCog is the any-to-any execution layer already running inside the
          OpenClaw network. Add it to your agents in minutes.
        </p>
        <Button
          type="primary"
          size="large"
          className="openclaw-close__cta"
          onClick={onGetApiKey}
          data-msc-suppress
        >
          {ctaLabel}
          <ArrowRightOutlined />
        </Button>
      </div>
    </section>
  );
};

export default OpenClawClose;
